
import { Subscription } from 'rxjs';
import { AfterViewInit, Component, OnInit, OnDestroy, Inject, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Side_Bar } from '@core/common/common-config';
import { SessionStorageService } from '@core/services/session-storage.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { AuthCoreService } from '@page/auth/auth.service';
import { UserDetailsService } from '@core/services/user-details.service';
import { CommonService } from '@core/services/common.service';
import {PermissionServiceService} from "@core/services/permission-service.service";
import { SidebarService } from './sidebar-service.service';
@Component({
  selector: 'relipay-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {


  sidebarList: any = [...Side_Bar];
  selectedItem: any = 0;
  loginSession: any;
  selectedBottom: any;
  dashboardStatic = {
    icon:
      "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n    <g id=\"dashboard\" transform=\"translate(0.001 2)\">\n      <g id=\"Group_71181\" data-name=\"Group 71181\">\n        <rect id=\"Rectangle_20970\" data-name=\"Rectangle 20970\" width=\"24\" height=\"24\" transform=\"translate(-0.001 -2)\" fill=\"none\"/>\n      </g>\n      <g id=\"Group_71182\" data-name=\"Group 71182\" transform=\"translate(0 -1)\">\n        <path id=\"Path_268283\" data-name=\"Path 268283\" d=\"M140.423,85.853a2.149,2.149,0,0,0-2.153,2.153v13.808a2.149,2.149,0,0,0,2.153,2.153h7.753v1.141a2.609,2.609,0,0,0-2.328,2.744h8.842a2.609,2.609,0,0,0-2.329-2.744v-1.141H156l-1.76-2.078H141.127a.884.884,0,0,1-.779-.965V88.9a.885.885,0,0,1,.779-.965h18.285a.886.886,0,0,1,.779.965v12.029a.886.886,0,0,1-.779.965h-.073l1.26,1.239a1.562,1.562,0,0,1,.463.619,2.145,2.145,0,0,0,1.2-1.933V88.006a2.149,2.149,0,0,0-2.153-2.153Z\" transform=\"translate(-138.271 -85.853)\" fill-rule=\"evenodd\"/>\n        <path id=\"Path_268284\" data-name=\"Path 268284\" d=\"M252.244,149.29a5.768,5.768,0,0,0-5.77,5.939,1.464,1.464,0,0,1,1,.079l.485-.412a4.285,4.285,0,0,1,8.382-1.08l1.3-.794a5.757,5.757,0,0,0-5.4-3.732Z\" transform=\"translate(-240.339 -145.694)\"/>\n        <path id=\"Path_268285\" data-name=\"Path 268285\" d=\"M282.6,250.619l-1.6.979-.017.088a4.283,4.283,0,0,1-7.193,2,3.926,3.926,0,0,1-.31-.347,2.044,2.044,0,0,1-.951,1.18c.068.075.138.149.209.22a5.783,5.783,0,0,0,7.349.682l4.771,5.616a1.426,1.426,0,0,0,2-2l-5.265-5.126a5.749,5.749,0,0,0,1.009-3.294Z\" transform=\"translate(-264.917 -241.279)\"/>\n        <path id=\"Path_268286\" data-name=\"Path 268286\" d=\"M231.512,195.777a.681.681,0,1,1-.681.68A.674.674,0,0,1,231.512,195.777Zm7.731-1.9a.681.681,0,1,1-.681.68A.673.673,0,0,1,239.243,193.881Zm-4.394-.891a.682.682,0,1,1-.681.68A.673.673,0,0,1,234.849,192.99Zm9.341-1.308a.681.681,0,1,1-.68.681A.675.675,0,0,1,244.189,191.682Zm0-.75a1.388,1.388,0,0,0-1.4,1.682l-2.25,1.378a1.4,1.4,0,0,0-2.6.031l-1.678-.492a1.423,1.423,0,1,0-2.762.564l-1.311,1.113a1.39,1.39,0,0,0-.673-.182,1.43,1.43,0,1,0,1.431,1.429,1.416,1.416,0,0,0-.213-.728l1.183-1a1.4,1.4,0,0,0,.935.378,1.425,1.425,0,0,0,1.281-.825l1.714.5a1.415,1.415,0,0,0,2.8.035l2.48-1.517a1.426,1.426,0,1,0,1.069-2.361Z\" transform=\"translate(-224.878 -184.975)\"/>\n      </g>\n    </g>\n  </svg>\n  ",
    id: 2,
    is_active: 1,
    name: "Dashboard",
    routeUrl: "dashboard"
  }

  userDetail: any = {
    // profile_picture: 'assets/assets/img/profile-img.jpg'
  }

  isShown: boolean = false
  title: string;

  public set _title(v: string) {
    this.title = v;
  }

  public get _title(): string {
    return this.title;
  }

  titleName: any;

  public set _titleName(v: string) {
    this.titleName = v;
  }

  public get _titleName(): string {
    return this.titleName;
  }


  payoutSideBar: any = null;

  public set _payoutSideBar(v: any) {
    // console.log(v);
    for (let i = 0; i < v?.length; i++) {
      if (!this._permissionService.hasPermission(v[i].permission)) {
        v.splice(i, 1);
        i--;
      }
    }
    this.payoutSideBar = v;
  //   open the first menu by default
    if (this.payoutSideBar && this.payoutSideBar.length > 0) {
      this.router.navigate([this.payoutSideBar[0].routePath]);
    }
  }

  public get _payoutSideBar(): any {
    return this.payoutSideBar;
  }

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private authService: AuthCoreService,
    private router: Router,
    private sessionStorage: SessionStorageService,
    private sanitizer: DomSanitizer,
    private _UserDetailsService: UserDetailsService,
    private _CommonService: CommonService,
    public _permissionService: PermissionServiceService,
    private _sidebarService: SidebarService
  ) {
    this._sidebarService.sideBarList.subscribe((res: any) => {
      if(res) {
        console.log(res);
        this.sidebarList = res;
      }
    })

    // console.log(this._payoutSideBar)


    this._CommonService.pageTitle.subscribe((e) => {
      this._titleName = e;
    })

    this._CommonService.subMenu.subscribe((e) => {
        if (e) {
          this._payoutSideBar = e;
        } else {
          this._payoutSideBar = null;
        }
    })
  }


  ngOnInit(): void {

    this._sidebarService.refreshSidebar();
    this._sidebarService.selectedItem.subscribe(res => this.selectedItem = res)
    // console.log(this.sidebarList)

    this._UserDetailsService.getUserLoginDetails.subscribe((_userDetail: any) => {
      if (_userDetail) {
        _userDetail.data.profile_picture = _userDetail.data.profile_picture ? _userDetail.data.profile_picture : 'assets/assets/img/profile-img.jpg';
        this.userDetail = _userDetail.data;
      }
    })
    const selectItem = this.sessionStorage.getItem('selectd_item') ? JSON.parse(this.sessionStorage.getItem('selectd_item')) : '';
    this.selectedItem = Number(selectItem) >= 0 ? Number(selectItem) : '';
    this.selectedBottom = selectItem;

  }

  onHelp() {
    this.router.navigate(['./help'])
  }

  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  ngAfterViewInit() {
    // setTimeout(() => App.init(), 300)


  }
  onSideBar(item?, index?) {
    console.log(item)
    this.selectedBottom = '';
    let session: any = this.sessionStorage.getItem('userDetails');
    this.loginSession = JSON.parse(session).data?.is_kyc == 1;

    if(item?.subMenu && item?.subMenu.length > 0)
    {
      this.router.navigate([`${item?.subMenu[0]?.routePath}`]);
    }
    else if(item?.routeUrl)
      this.router.navigate([`${item.routeUrl}`]);


    this.sessionStorage.setItem('selectd_item', index);
    if (this.loginSession) this.selectedItem = index;
  };

  clickProfile() {
    this.selectedItem = 50;
    this.router.navigate(['profile']);
    this.sessionStorage.setItem('selectd_item', this.selectedItem);
  };

  showhide() {
    if (!this.isShown) {
      this.isShown = true;
      this.document.body.classList.add('sidebar-noneoverflow');
      this.authService.toggleCols(true)
    } else {
      this.isShown = false;
      this.document.body.classList.remove('sidebar-noneoverflow');
      this.authService.toggleCols(false)
    }
  }

  bottomsidebar(selected) {
    this.selectedBottom = selected;
    this.selectedItem = '';
    this.sessionStorage.setItem('selectd_item', selected);
  }

  logOut() {
    this.authService.logout();
  }
  ngOnDestroy(): void {
    this.sessionStorage.removeItem('selectd_item');
  }

  debug(item: any) {
    return item.value;
  }
}
